<template>
  <div :style="{'display': checkPerm}"><slot v-if="checkPerm"/></div>
</template>

<script>
export default {
  name: "PermissionComponent",
  props: {
    permission: {
      type: String,
      default: ''
    },
    permissions: {
      type: Array,
      default: []
    },
    anyOfPermissions: {
      type: Array,
      default: []
    },
  },
  computed: {
    checkPerm() {
      const perms = this.$store.state.user ? (Array.isArray(this.$store.state.user.permissions) ? this.$store.state.user.permissions : []) : []
      if(perms.indexOf("admin") >= 0) return true
      if (this.permission) {
        return perms.indexOf(this.permission) >= 0
      }
      if (this.anyOfPermissions.length > 0) {
        for (const p of this.anyOfPermissions) {
          if (perms.indexOf(p) >= 0) return true
        }
      }
      if (this.permissions.length > 0) {
        for (const p of this.permissions) {
          if (perms.indexOf(p) < 0) return false
        }
      }
      return false
    }
  },
}
</script>

<style scoped>

</style>